import { log, logError } from '../webUtils'
import { userTypes } from '../consts/userTypes'

// Pas de notion d'instance ni de mission

const users = (state = [], action) => {
  switch (action.type) {
    case 'PUSH_NEW_USER':
      if (state.find(({ userHandlerId }) => userHandlerId == action.userHandlerId)) {
        return state.map(user => {
          if (user.userHandlerId == action.userHandlerId)
            return {
              ...user,
              username: action.username,
              userType: action.userType,
              sessionId: action.sessionId,
            }
          else
            return user;
        });
      }
      return [...state, {
        userHandlerId: action.userHandlerId,
        userProfileId: action.userProfileId,
        username: action.username,
        userType: action.userType,
        sessionId: action.sessionId
      }];
    case 'PUSH_REMOVE_USER_FROM_SESSION':
      return state.map(user => {
        if (user.userHandlerId == action.userHandlerId) {
          return { ...user, isInSession: false }
        }
        else
          return user
      })
    case 'PUSH_USER_LIST':
      return action.state.users;
    case userTypes.DOWN_USERS_USERNAME_UPDATE:
      return state.map(user => {
        if (user.userHandlerId == action.userHandlerId) {
          return { ...user, username: action.username }
        }
        else
          return user
      })
    case 'PUSH_SESSION_STATE':
      if (typeof action.state.users !== null) {
        return action.state.users;
      }
      else {
        console.log('Error PUSH_SESSION_STATE no users')
        return state;
      }
    default:
      return state
  } 
}

export default users 